/**
 * Decléor — product FAQ accordion (sections/section-product-faq.liquid).
 *
 * Deliberately small. All the motion is CSS (the panel animates grid-template-rows 0fr → 1fr, the
 * plus rotates into a minus), so this file only owns STATE:
 *   1. open / close a question, keeping aria-expanded truthful
 *   2. optionally close the others, so only one answer is open at a time
 *   3. the "See more" toggle that reveals the questions past the visible limit
 *
 * Nothing here measures heights. That is the point of the CSS approach — an answer that rewraps on
 * resize, or reflows when Museo finishes loading, needs no recalculation.
 *
 * ES5 IIFE, loaded with `defer` from the section. No dependencies.
 */
(function () {
  'use strict';

  var ROOT = '[data-faq]';

  /* closest() rather than walking parentNode by hand: the manual walk had to test className on
     every ancestor, and would have thrown the moment it stepped past the last element. */
  function item(trigger) {
    return trigger.closest ? trigger.closest('.dc-faq__item') : null;
  }

  function setOpen(el, open) {
    if (!el) {
      return;
    }
    var trigger = el.querySelector('[data-faq-trigger]');
    if (open) {
      el.classList.add('is-open');
    } else {
      el.classList.remove('is-open');
    }
    if (trigger) {
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  }

  function bind(root) {
    if (root.getAttribute('data-faq-bound') === '1') {
      return;
    }
    root.setAttribute('data-faq-bound', '1');

    var single = root.getAttribute('data-single') === 'true';
    var triggers = root.querySelectorAll('[data-faq-trigger]');
    var i;

    for (i = 0; i < triggers.length; i += 1) {
      triggers[i].addEventListener('click', function (event) {
        var el = item(event.currentTarget);
        if (!el) {
          return;
        }
        var open = !el.classList.contains('is-open');
        var others;
        var j;

        if (open && single) {
          others = root.querySelectorAll('.dc-faq__item.is-open');
          for (j = 0; j < others.length; j += 1) {
            if (others[j] !== el) {
              setOpen(others[j], false);
            }
          }
        }
        setOpen(el, open);
      });
    }

    var more = root.querySelector('[data-faq-more]');
    if (!more) {
      return;
    }
    more.addEventListener('click', function () {
      var expanded = !root.classList.contains('is-expanded');
      if (expanded) {
        root.classList.add('is-expanded');
      } else {
        root.classList.remove('is-expanded');
      }
      more.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      var hidden = root.querySelectorAll('.dc-faq__item--extra.is-open');
      var k;
      var label = expanded ? 'data-label-less' : 'data-label-more';
      var text = root.getAttribute(label);
      if (text) {
        more.textContent = text;
      }

      /* Collapsing hides the extra rows with display:none. Any of them left open would still be
         open on the next reveal, so the list would come back part-unfolded. Close them on the way
         out and the reveal always looks the same. */
      if (!expanded) {
        for (k = 0; k < hidden.length; k += 1) {
          setOpen(hidden[k], false);
        }
      }
    });
  }

  function init(scope) {
    var roots = (scope || document).querySelectorAll(ROOT);
    var i;
    for (i = 0; i < roots.length; i += 1) {
      bind(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  /* Theme editor re-renders the section on every settings change, replacing the nodes. */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
